import r,{memo as $,useMemo as E,useId as fe,forwardRef as b,useRef as I,useState as ye,useEffect as j,createContext as Ce,useContext as xe}from"react";import{ChevronRightIcon as ke,CrossThinIconDeprecated as G,ChevronDownIcon as V,CheckmarkIconDeprecated as Ee,SquareCheckIconDeprecated as we,SquareIconDeprecated as Fe,TriangleExclamationIcon as C,CloseIcon as W,DoubleArrowLeftIcon as Ie,DoubleArrowRightIcon as Se,CircleInfoOutlinedIcon as ze}from"@village/icons";import Me,{components as H}from"react-select";import i,{css as f,useTheme as g,createGlobalStyle as Be,ThemeProvider as De}from"styled-components";import{Select as Te,OutlinedInput as Ae,Button as We,CircularProgress as He,Tabs as Re,Tab as Oe,Chip as Pe,IconButton as S,Checkbox as _e,FormControlLabel as K,Radio as Le,Drawer as U,Tooltip as Ne,Menu as qe,MenuItem as je,TableContainer as Ge,Table as Ve,TableBody as Ke,TableCell as Ue,TableRow as Ze,TableHead as Je,ClickAwayListener as Qe}from"@material-ui/core";import{rem as o,normalize as Xe,rgba as v}from"polished";import{useCombinedRef as Ye,useOnKeydown as et,KeyboardKey as tt,useFocusManager as ot,useFocusTrap as rt,useIsMobile as nt,useToggle as it}from"@village/tools";import{createPortal as at}from"react-dom";import{CSSTransition as lt}from"react-transition-group";import{useInView as dt}from"react-intersection-observer";import ct from"@material-ui/core/Tooltip";import{withStyles as st,createTheme as ut,StylesProvider as pt,MuiThemeProvider as mt}from"@material-ui/core/styles";const R=o(16),ht=o(16),O=o(16),P=o(40),bt=e=>e?`calc(100% - ${R} - ${O} - ${P})`:`calc(100% - ${R})`,gt=e=>Boolean(e.onClick??e.onKeyPress??e.onKeyUp),vt=({$type:e,$fontWeight:t,$uppercase:a})=>f`
    margin: 0;
    font-size: ${({theme:l})=>l.vui.typography[l.vui.platform][e].fontSize};
    font-weight: ${({theme:l})=>t??l.vui.typography[l.vui.platform][e].fontWeight};
    line-height: ${({theme:l})=>l.vui.typography[l.vui.platform][e].lineHeight};
    text-transform: ${a?"uppercase":null};
`,$t=i.span`
    ${e=>vt(e)};
`,ft={caption1:"p",caption2:"p",caption:"p",body1:"p",body2:"p",h1:"h1",h2:"h2",h3:"h3",h4:"h4",h5:"h5",h6:"h6",sub1:"span",sub2:"span",sub3:"p",sub4:"p",titleCaps:"span"},h=({type:e,tag:t,fontWeight:a,uppercase:l,className:c,...s})=>{const d=g();return e in d.vui.typography[d.vui.platform]?r.createElement($t,{"data-tag":e,as:t??ft[e],$type:e,$fontWeight:a,$uppercase:l,className:c,...s}):(console.warn(`Unsupported typography element ${e} for platform ${d.vui.platform}`),r.createElement("span",{"data-tag":"unsupported-type"},s.children))},yt=i(h).attrs(()=>({tag:"div",type:"titleCaps"}))`
    ${({$position:e})=>e==="sticky"&&f`
            position: sticky;
            top: 0;
            z-index: 1;
        `};
    padding: ${o(14)} ${o(16)};
    color: ${({theme:e})=>e.vui.colors.text.grayMuted};
    background-color: ${({theme:e})=>e.vui.colors.background.gray};
`,Z=i.hr`
    position: absolute;
    bottom: -0.5px;
    right: 0;
    width: ${({$hasIcon:e})=>bt(e)};
    height: 1px;
    margin: 0;
    border: none;
    background-color: ${({theme:e})=>e.vui.colors.border.divider.default};
    opacity: 1;
    transition: opacity 300ms;
`,Ct=i.div`
    position: relative;
    display: flex;
    align-items: center;
    padding: ${R};

    ${({$isInteractive:e})=>e&&f`
            &:active {
                background-color: ${({theme:t})=>t.vui.colors.decorative.neutral.gray10};

                /* Hide divider on active, so the background looks complete */
                ${Z} {
                    opacity: 0;
                }
            }

            transition: background-color 300ms;
        `};
`,xt=i(h).attrs(()=>({type:"body1",tag:"div"}))`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    color: ${({theme:e})=>e.vui.colors.text.grayMuted};
`,_=i.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${P};
    height: ${P};
    margin-right: ${O};
    border-radius: 50%;
    overflow: hidden;

    > * {
        flex: 1;
    }
`,J=i.div`
    display: flex;
    width: ${o(90)};
    height: ${o(56)};
    margin-right: ${O};
    align-items: center;
    justify-content: center;
    overflow: hidden;
`,kt=i(ke).attrs(()=>({size:"sm"}))`
    color: ${({theme:e})=>e.vui.colors.icon.grayPale};
    margin-left: ${ht};
`,Et=$(({title:e,headerPosition:t,children:a})=>r.createElement("div",null,e?r.createElement(yt,{$position:t},e):null,r.createElement("div",null,a))),Q=$(({children:e,hideChevron:t,picture:a,icon:l,...c})=>{const s=gt(c);return r.createElement(Ct,{$isInteractive:s,...c},l?r.createElement(_,null,l):null,a?r.createElement(J,null,a):null,r.createElement(xt,null,e),s&&!t?r.createElement(kt,null):null,r.createElement(Z,{$hasIcon:!!l}))}),wt=i(G)`
    color: ${({theme:e})=>e.vui.colors.icon.graySubtle};
    height: ${o(12)};
    width: ${o(12)};
`,Ft=i(V)`
    color: ${({theme:e})=>e.vui.colors.icon.graySubtle};
    height: ${o(16)};
    width: ${o(16)};
`,X=i.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${o(16)};
    width: ${o(16)};
    cursor: pointer;
`,It=i(G)`
    height: ${o(12)};
    width: ${o(12)};
`,St=i(Ee)`
    color: ${({theme:e})=>e.vui.colors.icon.graySubtle};
`,zt=i(we)`
    color: ${({theme:e})=>e.vui.colors.icon.primary};
`,Mt=i(Fe)`
    color: ${({theme:e})=>e.vui.colors.icon.primary};
`,Bt=i.div`
    position: relative;
`,Y=i(h).attrs(()=>({tag:"label"}))`
    display: block;
    margin-bottom: ${o(6)};
    color: ${({theme:e})=>e.vui.component.autocomplete.default.textColor};
`,Dt=i.img`
    width: ${o(40)};
    height: ${o(40)};
    object-fit: contain;
`,ee=i(h)`
    margin-top: ${o(8)};
    color: ${({theme:e,$error:t})=>t?e.vui.colors.text.error:e.vui.colors.text.graySubtle};
    display: flex;
    align-items: center;
    column-gap: ${o(4)};
`,Tt=i.div`
    .vui-autocomplete-container {
        .vui-autocomplete--is-disabled {
            border: 1px solid ${({theme:e})=>e.vui.colors.border.default.disabled};
            background: ${({theme:e})=>e.vui.colors.background.gray};
            color: ${({theme:e})=>e.vui.colors.text.disabled};
        }

        .vui-autocomplete__control {
            position: relative;
            border-radius: 5px;
            padding: 0 ${o(16)};
            min-height: ${o(56)};
            color: ${({theme:e})=>e.vui.component.autocomplete.default.textColor};
            border-style: solid;
            border-color: ${({theme:e,$error:t})=>t?e.vui.colors.border.error.emphasis:e.vui.colors.border.default.default};
            box-shadow: ${({$error:e,theme:t})=>e?`inset ${t.vui.colors.border.error.emphasis} 0 0 0 1px`:"none"};

            &--menu-is-open,
            &--is-focused {
                color: ${({theme:e})=>e.vui.component.autocomplete.default.textColor};
                border-color: ${({theme:e,$error:t})=>t?e.vui.colors.border.error.emphasis:e.vui.colors.border.primary.emphasis};
                box-shadow: inset
                    ${({$error:e,theme:t})=>e?t.vui.colors.border.error.emphasis:t.vui.colors.border.primary.emphasis}
                    0 0 0 1px;
            }

            /* Add hover styles only when hover effect is supported */
            @media (hover: hover) {
                &:hover {
                    border-color: ${({theme:e,$error:t})=>t?e.vui.colors.border.error.emphasis:e.vui.colors.border.default.hovered};
                }
                &--is-focused:hover,
                &--menu-is-open:hover {
                    border-color: ${({theme:e,$error:t})=>t?e.vui.colors.border.error.emphasis:e.vui.colors.border.primary.emphasis};
                }
            }
        }

        .vui-autocomplete__placeholder {
            color: ${({theme:e})=>e.vui.colors.text.hint};
            line-height: 1.5;
        }

        .vui-autocomplete__value-container {
            border-color: ${({theme:e})=>e.vui.colors.border.default.default};
            padding: 0;
            cursor: ${({$isSearchable:e})=>e?"text":"pointer"};

            &--is-multi {
                gap: ${o(8)};
                padding: ${o(12)} 0;
            }
        }

        .vui-autocomplete__input-container {
            padding: 0;
            margin: 0;
            color: ${({theme:e})=>e.vui.component.autocomplete.default.textColor};
            line-height: 1.5;
        }

        .vui-autocomplete__menu {
            background: ${({theme:e})=>e.vui.colors.background.white};
            box-shadow: 0 2px 4px 0 rgba(23, 51, 91, 0.2);
            border-radius: 4px;
            padding: ${o(4)} 0;

            .vui-autocomplete__menu-list {
                padding: 0;

                * {
                    color: ${({theme:e})=>e.vui.component.autocomplete.default.textColor};
                }
            }

            .vui-autocomplete__menu-notice {
                background: ${({theme:e})=>e.vui.colors.background.white};
                color: ${({theme:e})=>e.vui.colors.text.graySubtle};
                margin: 0;
                padding: ${o(8)} ${o(12)} ${o(8)} ${o(16)};
            }

            hr {
                display: none;
            }

            .vui-autocomplete__group {
                padding: 0;

                .vui-autocomplete__group-heading {
                    background: ${({theme:e})=>e.vui.colors.background.gray};
                    color: ${({theme:e})=>e.vui.component.autocomplete.default.textColor};
                    font-size: ${o(14)};
                    padding: ${o(8)} ${o(16)};
                    line-height: 1.5;
                }
            }
        }
        .vui-autocomplete__multi-value {
            display: flex;
            align-items: center;
            height: ${o(28)};
            padding: 0 ${o(4)} 0 ${o(8)};
            margin: 0;
            font-size: ${o(14)};
            line-height: 1.5;
            background-color: ${({theme:e})=>e.vui.colors.surface.primary};
            border-radius: 4px;

            &__label {
                margin-right: ${o(4)};
                padding: 0;
                color: ${({theme:e})=>e.vui.colors.text.grayDefault};
                font-size: inherit;
            }

            &__remove {
                cursor: pointer;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                height: ${o(20)};
                width: ${o(20)};

                /* Add hover styles only when hover effect is supported */
                @media (hover: hover) {
                    &:hover {
                        color: ${({theme:e})=>e.vui.colors.icon.primary};
                        background-color: ${({theme:e})=>e.vui.colors.action.tertiary.hovered};
                    }
                }
                &:active {
                    background-color: ${({theme:e})=>e.vui.colors.action.tertiary.pressed};
                }
            }
        }

        .vui-autocomplete__single-value {
            line-height: 1.5;
            color: ${({theme:e})=>e.vui.component.autocomplete.default.textColor};
        }
    }
`,At=i(_)`
    margin-right: 0;
`,te=i.div`
    background: transparent;
    color: ${({theme:e})=>e.vui.colors.text.grayDefault};
    padding: ${({$isMulti:e,$isSelected:t})=>`${o(8)} ${o(16)} ${o(8)} ${!t&&!e?o(44):o(16)}`};
    margin: 0;

    /* Add hover styles only when hover effect is supported */
    @media (hover: hover) {
        &:hover {
            background: ${({theme:e})=>e.vui.colors.decorative.neutral.gray5};
        }
    }

    ${({$isFocused:e})=>e&&f`
            background: ${({theme:t})=>t.vui.colors.decorative.neutral.gray10};
        `}
`,L=i(Q)`
    padding: 0;

    & > ${_} {
        width: ${({$isMulti:e})=>e?o(24):o(16)};
        height: ${({$isMulti:e})=>e?o(24):o(16)};
        margin-right: ${o(12)};
    }

    & > ${J} {
        margin-right: ${o(12)};
        width: ${o(40)};
        height: ${o(40)};
    }
`,Wt=i(V).attrs(()=>({size:"sm"}))`
    right: ${o(16)};
    top: calc(50% - 8px);
`,Ht=i(Te)`
    .MuiSelect-select {
        background-color: transparent;
    }

    select.MuiSelect-root.MuiOutlinedInput-input:not(.MuiOutlinedInput-inputMultiline) {
        padding-right: ${o(38)};
    }
`,Rt=({selectProps:e,innerProps:t})=>{const{hideClearIndicator:a}=e;return a?null:r.createElement("div",{...t},r.createElement(X,null,r.createElement(wt,null)))},Ot=({selectProps:e,innerProps:t})=>{const{isSearchable:a,hideDropdownIndicator:l}=e;return a||l?null:r.createElement("div",{...t},r.createElement(X,null,r.createElement(Ft,null)))},Pt=({children:e,selectProps:t,...a})=>{const{startAdornment:l,endAdornment:c}=t;return r.createElement(H.Control,{selectProps:t,...a},l,e,c)},_t=e=>r.createElement(H.NoOptionsMessage,{...e},r.createElement(L,null,e.selectProps.noOptionsMessage({inputValue:e.selectProps.inputValue})??"No items found.")),oe=(e,t)=>t?e?r.createElement(zt,{size:1.5}):r.createElement(Mt,{size:1.5}):e?r.createElement(St,{size:1.5}):null,Lt=e=>{const{children:t,innerRef:a,innerProps:l,isSelected:c,isFocused:s,isMulti:d}=e;return r.createElement("div",{ref:a,...l},r.createElement(te,{$isSelected:c,$isFocused:s,$isMulti:d},r.createElement(L,{icon:oe(c,d),$isSelected:c,$isMulti:d},r.createElement("div",null,t))))},Nt=e=>{const{children:t,data:a,innerRef:l,innerProps:c,isSelected:s,isFocused:d,isMulti:u}=e,{img:p}=a,m=r.createElement(At,null,r.createElement(Dt,{src:p}));return r.createElement("div",{ref:l,...c},r.createElement(te,{$isSelected:s,$isFocused:d,$isMulti:u},r.createElement(L,{icon:oe(s,u),picture:m,$isSelected:s,$isMulti:u},r.createElement("div",null,t))))},qt=e=>r.createElement(H.MultiValueRemove,{...e},r.createElement(It,null)),re={Control:Pt,ClearIndicator:Rt,DropdownIndicator:Ot,MultiValueRemove:qt,NoOptionsMessage:_t,Option:Lt,OptionWithImage:Nt},ne=i.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`,z=i(h).attrs(()=>({tag:"label"}))`
    display: block;
    margin-bottom: ${o(6)};
    color: ${({theme:e})=>e.vui.component.input.default.default.textColor};
`,M=i(h)`
    margin-top: ${o(8)};
    color: ${({theme:e,$error:t})=>t?e.vui.colors.text.error:e.vui.colors.text.graySubtle};
    display: flex;
    align-items: center;
    column-gap: ${o(4)};
`,ie=i(Ae)`
    &.MuiOutlinedInput-root {
        color: ${({theme:e,$status:t})=>e.vui.component.input[t].default.textColor};
        background-color: ${({theme:e,$status:t})=>e.vui.component.input[t].default.backgroundColor};

        &.MuiOutlinedInput-multiline {
            padding: ${o(13)} ${o(16)};
            min-height: ${o(56)};
        }

        .MuiOutlinedInput-input {
            font-size: ${o(16)};
            line-height: 1.3;
            box-sizing: border-box;
        }

        .MuiInputAdornment-root {
            pointer-events: none;
        }

        .MuiOutlinedInput-input:not(.MuiOutlinedInput-inputMultiline) {
            padding: ${o(13)} ${o(16)};
            height: ${o(56)};

            &.MuiOutlinedInput-inputAdornedStart {
                padding-left: 0;
            }

            &.MuiOutlinedInput-inputAdornedEnd {
                padding-right: 0;
            }
        }

        .MuiOutlinedInput-notchedOutline {
            border-color: ${({theme:e,$status:t})=>e.vui.component.input[t].default.borderColor};
            border-width: ${({theme:e,$status:t})=>e.vui.component.input[t].default.borderWidth}px;
        }

        &.Mui-focused {
            color: ${({theme:e,$status:t})=>e.vui.component.input[t].focus.textColor};
            background-color: ${({theme:e,$status:t})=>e.vui.component.input[t].focus.backgroundColor};

            .MuiOutlinedInput-notchedOutline {
                border-color: ${({theme:e,$status:t})=>e.vui.component.input[t].focus.borderColor};
                border-width: ${({theme:e,$status:t})=>e.vui.component.input[t].focus.borderWidth}px;
            }
        }

        /* Add hover styles only when hover effect is supported */
        @media (hover: hover) {
            &:hover:not(.Mui-focused) {
                color: ${({theme:e,$status:t})=>e.vui.component.input[t].hover.textColor};
                background-color: ${({theme:e,$status:t})=>e.vui.component.input[t].hover.backgroundColor};

                .MuiOutlinedInput-notchedOutline {
                    border-color: ${({theme:e,$status:t})=>e.vui.component.input[t].hover.borderColor};
                    border-width: ${({theme:e,$status:t})=>e.vui.component.input[t].hover.borderWidth}px;
                }
            }
        }
    }
`,ae=e=>e.error?"error":e.disabled||e.readOnly?"disabled":"default",jt=({label:e,id:t,inputProps:a,options:l,onChange:c,hideErrorIcon:s=!1,error:d,helperText:u,native:p,className:m,style:x,disabled:k})=>{const B=g(),y=Boolean(d),D=E(()=>ae({disabled:k,error:d}),[k,d]);return r.createElement(ne,{className:m,style:x},e?B.vui.platform==="web"?r.createElement(z,{htmlFor:t,forwardedAs:"label",type:"caption1"},e):r.createElement(z,{htmlFor:t,forwardedAs:"label",type:"sub2"},e):null,r.createElement(Ht,{id:t,...a,disabled:k,onChange:c,native:p,input:r.createElement(ie,{$status:D}),IconComponent:Wt},l?.map(({value:T,label:A})=>r.createElement("option",{key:T,value:T},A))),u||y?B.vui.platform==="web"?r.createElement(M,{$error:y,type:"caption2"},y&&!s?r.createElement(C,{size:"sm"}):null," ",d??u):r.createElement(M,{$error:y,type:"caption"},y&&!s?r.createElement(C,{size:"sm"}):null," ",d??u):null)},{Control:Gt,ClearIndicator:Vt,DropdownIndicator:Kt,MultiValueRemove:Ut,NoOptionsMessage:Zt,Option:Jt}=re,Qt=({components:e,label:t,helperText:a,error:l,isSearchable:c,hideErrorIcon:s=!1,...d})=>{const u=g(),p=Boolean(l),m=fe(),x=E(()=>({Control:Gt,ClearIndicator:Vt,DropdownIndicator:Kt,IndicatorSeparator:void 0,NoOptionsMessage:Zt,Option:Jt,MultiValueRemove:Ut,...e}),[e]);return r.createElement(Bt,null,t?u.vui.platform==="web"?r.createElement(Y,{htmlFor:m,forwardedAs:"label",type:"caption1"},t):r.createElement(Y,{htmlFor:m,forwardedAs:"label",type:"sub2"},t):null,r.createElement(Tt,{$error:p,$isSearchable:c},r.createElement(Me,{components:x,className:"vui-autocomplete-container",classNamePrefix:"vui-autocomplete",isSearchable:c,inputId:m,...d})),a||p?u.vui.platform==="web"?r.createElement(ee,{$error:p,type:"caption2"},p&&!s?r.createElement(C,{size:"sm"}):null," ",l??a):r.createElement(ee,{$error:p,type:"caption"},p&&!s?r.createElement(C,{size:"sm"}):null," ",l??a):null)},Xt=e=>"native"in e?r.createElement(jt,{...e}):r.createElement(Qt,{...e}),Yt=i(We)`
    width: ${({$fullWidth:e})=>e?"100%":"auto"};
    min-width: 4rem;
    box-sizing: border-box;
    font-size: ${({theme:e,$size:t})=>e.vui.component.button.size[t].fontSize};
    font-weight: 500;
    padding: ${({theme:e,$size:t})=>e.vui.component.button.size[t].padding};
    border-radius: ${({theme:e,$size:t})=>e.vui.component.button.size[t].borderRadius};
    line-height: ${({theme:e,$size:t})=>e.vui.component.button.size[t].lineHeight};
    text-transform: none;

    > span {
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        color: inherit;
    }

    &,
    /* Material-ui has some styles for hover state that we need to override (reset to default state) */
    &:hover {
        background-color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].default.background};
        border: 1px solid ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].default.border};
        color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].default.font};
    }

    /* Add hover styles only when hover effect is supported */
    @media (hover: hover) {
        &:hover {
            background-color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].hover.background};
            border-color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].hover.border};
            color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].hover.font};
        }
    }

    &:active {
        background-color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].pressed.background};
        border-color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].pressed.border};
        color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].pressed.font};
    }

    &:disabled,
    &.MuiButton-root.Mui-disabled {
        background-color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].disabled.background};
        border-color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].disabled.border};
        color: ${({theme:e,$variant:t})=>e.vui.component.button.variant[t].disabled.font};
    }
`,eo=b(({variant:e="primary",fullWidth:t=!1,size:a="large",...l},c)=>r.createElement(Yt,{$variant:e,$fullWidth:t,$size:a,ref:c,...l})),to=i(He)`
    color: ${({theme:e})=>e.vui.component.spinner.color};
`,oo=$(({size:e,...t})=>{const a=g();return r.createElement(to,{...t,size:e??a.vui.component.spinner.size})}),ro=8,le=3,no=i(Re)`
    background-color: ${({theme:e})=>e.vui.component.tab.background};

    /* Removing the width so we can calculate the real width of the tab label */
    .MuiTab-wrapper {
        width: unset;
    }

    .MuiTabs-indicator {
        height: ${le}px;
        background: transparent;
    }
`,io=i.span`
    display: block;
    position: relative;
    width: ${({width:e})=>e+ro}px;
    height: ${le}px;
    background-color: ${({theme:e})=>e.vui.component.tab.background};
    margin: 0 auto;
    transition: 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${({theme:e})=>e.vui.component.tab.indicator.color};
        border-radius: 2px 2px 0 0;
    }
`,ao=$(({variant:e="fullWidth",value:t,...a})=>{const l=I(null),c=I(null),[s,d]=ye(0);j(()=>{const p=l.current?.querySelector("[aria-selected=true] .MuiTab-wrapper");return d(p?.scrollWidth??0),p&&(c.current=new ResizeObserver(([{contentRect:m}])=>{d(m.width)}),c.current.observe(p)),()=>c.current?.disconnect()},[t]);const u=E(()=>({children:s>0?r.createElement(io,{width:s}):null}),[s]);return r.createElement(no,{ref:l,variant:e,...a,value:t,TabIndicatorProps:u})}),lo=i(Oe)`
    color: ${({theme:e})=>e.vui.component.tab.default.color};
    opacity: 1;
    text-transform: none;
    font-size: ${o(14)};

    &.Mui-selected {
        color: ${({theme:e})=>e.vui.component.tab.selected.color};
        font-weight: 600;
    }
`,co=$(e=>r.createElement(lo,{...e})),so=i(Pe)`
    color: ${({theme:e,$variant:t,$color:a})=>e.vui.component.chip.variant[t][a].color};
    background-color: ${({theme:e,$variant:t,$color:a})=>e.vui.component.chip.variant[t][a].backgroundColor};
    border: solid 1px ${({theme:e,$variant:t,$color:a})=>e.vui.component.chip.variant[t][a].border};
    padding: 0.5rem;
    text-transform: none;
    font-size: ${o(13)};
    font-weight: 600;

    /* Add hover styles only when hover effect is supported */
    @media (hover: hover) {
        &:hover {
            background: ${({theme:e,$variant:t,$color:a})=>e.vui.component.chip.variant[t][a].hoverBgColor};
        }
    }
`,uo=$(({variant:e="default",color:t="default",...a})=>r.createElement(so,{$variant:e,$color:t,...a})),po=$(b(({label:e,error:t,helperText:a,fullWidth:l,id:c,hideErrorIcon:s=!1,...d},u)=>{const p=g(),m=Boolean(t),x=E(()=>ae({disabled:d.disabled,error:t,readOnly:d.readOnly}),[d.disabled,t,d.readOnly]),k=E(()=>{if(d.type==="textarea"){const{rows:T,...A}=d;return A}const{endAdornment:B,startAdornment:y,...D}=d;return D},[d]);return r.createElement(ne,null,e?p.vui.platform==="web"?r.createElement(z,{htmlFor:c,forwardedAs:"label",type:"caption1"},e):r.createElement(z,{htmlFor:c,forwardedAs:"label",type:"sub2"},e):null,r.createElement(ie,{id:c,$status:x,error:m,fullWidth:l,multiline:d.type==="textarea",type:d.type==="textarea"?"text":d.type,startAdornment:d.type==="textarea"?void 0:d.startAdornment,endAdornment:d.type==="textarea"?void 0:d.endAdornment,disabled:d.disabled,inputRef:u,minRows:d.type==="textarea"?d.rows:void 0,inputProps:k}),a||m?p.vui.platform==="web"?r.createElement(M,{$error:m,type:"caption2"},m&&!s?r.createElement(C,{size:"sm"}):null," ",t??a):r.createElement(M,{$error:m,type:"caption"},m&&!s?r.createElement(C,{size:"sm"}):null," ",t??a):null)})),de={normal:{width:o(48),height:o(48)},small:{width:o(24),height:o(24)},wide:{width:o(100),height:o(56)}},mo=i.div`
    display: grid;
    grid-template-columns: ${({$pictureSize:e,$hasPicture:t})=>e&&t?de[e].width:0} 1fr;
    column-gap: ${({$pictureSize:e,$hasPicture:t})=>e&&t?o(16):0};
    background-color: ${({theme:e})=>e.vui.component.buttonCard.default.backgroundColor};
    border: 2px solid ${({theme:e})=>e.vui.component.buttonCard.default.borderColor};
    border-radius: ${o(8)};
    cursor: pointer;
    padding: ${o(20)} ${o(16)};
    line-height: 1.5;
    align-items: center;
    flex-wrap: wrap;

    ${({theme:e,$selected:t})=>t&&f`
            border: 2px solid ${e.vui.component.buttonCard.selected.borderColor};
        `};

    :active,
    :focus {
        border: 2px solid ${({theme:e})=>e.vui.component.buttonCard.selected.borderColor};
    }

    /* Add hover styles only when hover effect is supported */
    @media (hover: hover) {
        &:hover {
            border: 2px solid ${({theme:e})=>e.vui.component.buttonCard.selected.borderColor};
        }
    }
`,ce=i(h).attrs(()=>({tag:"div"}))`
    color: ${({theme:e})=>e.vui.component.buttonCard.default.titleColor};
`,ho=i(h).attrs(()=>({type:"body1",tag:"div"}))`
    color: ${({theme:e})=>e.vui.component.buttonCard.default.contentColor};
`,bo=i.div`
    display: flex;
    height: ${({$pictureSize:e})=>de[e].height};
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: ${({$pictureType:e})=>e==="circle"?"50%":"none"};
`,go=$(e=>{const t=g(),{selected:a=!1,picture:l,primaryText:c,children:s,pictureType:d="square",...u}=e,p="pictureSize"in e?e.pictureSize??"normal":"normal",m=Boolean(l);return r.createElement(mo,{$selected:a,$pictureSize:p,$hasPicture:m,...u},r.createElement("div",null,m?r.createElement(bo,{$pictureSize:p,$pictureType:d},l):null),r.createElement("div",null,t.vui.platform==="web"?r.createElement(ce,{type:"h6"},c):r.createElement(ce,{type:"sub1"},c),r.createElement(ho,null,s)))}),vo=i(S)`
    height: ${({theme:e,$size:t})=>e.vui.component.buttonIcon.size[t].size};
    width: ${({theme:e,$size:t})=>e.vui.component.buttonIcon.size[t].size};
    border-radius: ${({theme:e,$size:t})=>e.vui.component.buttonIcon.size[t].borderRadius};
    color: ${({theme:e})=>e.vui.component.buttonIcon.variant.default.color};
    background-color: ${({theme:e})=>e.vui.component.buttonIcon.variant.default.background};

    @media (hover: hover) {
        &:hover {
            color: ${({theme:e})=>e.vui.component.buttonIcon.variant.hover.color};
            background-color: ${({theme:e})=>e.vui.component.buttonIcon.variant.hover.background};
        }
    }

    &:active {
        background-color: ${({theme:e})=>e.vui.component.buttonIcon.variant.pressed.background};
        color: ${({theme:e})=>e.vui.component.buttonIcon.variant.pressed.color};
    }

    &:disabled,
    &.MuiButton-root.Mui-disabled {
        background-color: ${({theme:e})=>e.vui.component.buttonIcon.variant.disabled.background};
        color: ${({theme:e})=>e.vui.component.buttonIcon.variant.disabled.color};
    }
`,se=({size:e="large",...t})=>r.createElement(vo,{$size:e,...t}),$o=i.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${({theme:e})=>e.vui.component.modal.overlay.backgroundColor};
    transition: opacity ${({theme:e})=>`${e.vui.component.modal.timeout}ms`} ease-in-out;
`,w=i.section`
    max-width: 100%;
    max-height: 100%;
    overflow-y: auto;
    position: relative;
    background-color: ${({theme:e})=>e.vui.component.modal.container.backgroundColor};
    border-radius: ${({theme:e})=>e.vui.component.modal.container.borderRadius};
`,fo=i.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    isolation: isolate;
    z-index: 1;
    padding: ${o(16)};
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    transition: opacity ${({theme:e})=>`${e.vui.component.modal.timeout}ms`};

    &.fade-enter {
        opacity: 0;

        & > ${w} {
            transform: scale(0.9);
        }

        &.fade-enter-active {
            opacity: 1;

            & > ${w} {
                transform: scale(1);
                transition: transform ${({theme:e})=>`${e.vui.component.modal.timeout}ms`} ease-out;
            }
        }
    }
    &.fade-exit {
        opacity: 1;

        & > ${w} {
            transform: scale(1);
        }

        &.fade-exit-active {
            opacity: 0;

            & > ${w} {
                transform: scale(0.9);
                transition: transform ${({theme:e})=>`${e.vui.component.modal.timeout}ms`} ease-in;
            }
        }
    }
`,yo=i(se).attrs(()=>({size:"small"}))`
    position: absolute;
    top: ${o(16)};
    right: ${o(16)};
`,Co=i.div`
    padding: ${o(20)};
    border-bottom: ${({theme:e})=>e.vui.component.modal.border};
`,xo=i.div`
    padding: ${o(20)};
`,ko=i.div`
    padding: ${o(20)};
    border-top: ${({theme:e})=>e.vui.component.modal.border};
`,Eo=b(({children:e,onClose:t,open:a,className:l,hideCloseButton:c=!1},s)=>{const d=g(),u=I(null),p=Ye([s,u]);return et({callback:()=>t?.(),keyboardKeys:[tt.Esc],ref:u,shouldListen:a}),ot(u,a),rt(u,a),at(r.createElement(lt,{classNames:"fade",in:a,nodeRef:u,timeout:d.vui.component.modal.timeout,unmountOnExit:!0},r.createElement(fo,{ref:p,className:l},r.createElement($o,{"data-testid":"overlay",onClick:t}),r.createElement(w,{role:"dialog"},c?null:r.createElement(yo,{"aria-label":"close modal","data-testid":"modal-close-button",onClick:t},r.createElement(W,{"aria-label":"Close"})),e))),document.body)}),wo=i.hr`
    background-color: ${({theme:e})=>e.vui.colors.border.divider.default};
    width: 100%;
    height: ${o(1)};
    margin: 0;
    border: none;
    display: block;
`,Fo=i.div`
    width: ${o(1)};
    min-height: 100%;
    margin: 0;
    background-color: ${({theme:e})=>e.vui.colors.border.divider.default};
`,Io=({direction:e,...t})=>e==="vertical"?r.createElement(Fo,{...t}):r.createElement(wo,{...t}),ue=i.div`
    background-color: ${({theme:e})=>e.vui.component.card.backgroundColor};
    border-radius: ${({theme:e})=>e.vui.component.card.borderRadius};
    padding: ${({theme:e})=>e.vui.component.card.padding};
    box-shadow: ${({theme:e})=>e.vui.component.card.boxShadow};
`,So=i(_e)`
    &.MuiCheckbox-root {
        color: ${({theme:e})=>e.vui.colors.icon.primary};
        padding: 0;

        /* Add hover styles only when hover effect is supported */
        @media (hover: hover) {
            &:hover {
                background-color: transparent;
            }
        }
    }
    & .Mui-disabled {
        color: ${({theme:e})=>e.vui.colors.icon.disabled};
    }
`,zo=i(K)`
    &.MuiFormControlLabel-root {
        gap: ${o(8)};
        margin: 0;
    }
    & .Mui-disabled {
        color: ${({theme:e})=>e.vui.colors.text.disabled};
    }
    & .MuiFormControlLabel-label {
        font-family: inherit;
        letter-spacing: 0;
    }
`,Mo=b(({label:e,className:t,style:a,classes:l,...c},s)=>r.createElement(zo,{className:t,classes:l,style:a,inputRef:s,control:r.createElement(So,{...c}),label:r.createElement(h,{type:"body1",tag:"span"},e)})),Bo=i(Le)`
    &.MuiRadio-root {
        color: ${({theme:e})=>e.vui.colors.icon.primary};
        padding: 0;

        /* Add hover styles only when hover effect is supported */
        @media (hover: hover) {
            &:hover {
                background-color: transparent;
            }
        }
    }
    & .Mui-disabled {
        color: ${({theme:e})=>e.vui.colors.icon.disabled};
    }
`,Do=i(K)`
    &.MuiFormControlLabel-root {
        gap: ${o(8)};
        margin: 0;
    }
    & .Mui-disabled {
        color: ${({theme:e})=>e.vui.colors.text.disabled};
    }
    & .MuiFormControlLabel-label {
        font-family: inherit;
        letter-spacing: 0;
    }
`,To=b(({classes:e,className:t,style:a,label:l,...c},s)=>r.createElement(Do,{className:t,classes:e,style:a,inputRef:s,control:r.createElement(Bo,{...c}),label:r.createElement(h,{type:"body1",tag:"span"},l)})),pe=i.a`
    display: inline-flex;
    align-items: center;
    gap: ${o(4)};
    text-decoration: none;

    &,
    &:link,
    &:visited {
        color: ${({theme:e})=>e.vui.colors.action.primary.default};
    }

    &:hover,
    &:focus {
        color: ${({theme:e})=>e.vui.colors.action.primary.hovered};
    }

    :active {
        color: ${({theme:e})=>e.vui.colors.action.primary.pressed};
    }
`,me=i.i`
    line-height: 0;
`,he=b(({children:e,rightIcon:t,leftIcon:a,...l},c)=>r.createElement(pe,{ref:c,...l},a&&r.createElement(me,null,a),e,t&&r.createElement(me,null,t))),N=20,Ao=i(U)`
    & .MuiDrawer-paper {
        display: flex;
        background-color: ${({theme:e})=>e.vui.colors.surface.white};
        width: ${({anchor:e})=>e==="left"||e==="right"?`min(100vw, ${o(400)})`:"100%"};
    }
`,Wo=i.div`
    display: grid;
    position: relative;
    border-bottom: 1px solid ${({theme:e})=>e.vui.colors.border.divider.default};
    padding: ${o(N)};
`,Ho=i.div`
    flex-grow: 1;
    padding: ${o(N)};
`,Ro=i.div`
    display: flex;
    padding: ${o(N)};
    gap: ${o(16)};
`,Oo=i(S)`
    position: absolute;
    justify-self: flex-end;
    align-self: center;
    display: block;
    margin-right: ${o(8)};
    border-radius: 4px;
    color: ${({theme:e})=>e.vui.colors.icon.graySubtle};

    &:active {
        background-color: ${({theme:e})=>e.vui.colors.action.link.pressed};
    }

    @media (hover: hover) {
        &:hover {
            background-color: ${({theme:e})=>e.vui.colors.action.link.hovered};
        }
    }
`,Po=b(({anchor:e="left",children:t,...a},l)=>r.createElement(Ao,{anchor:e,...a,ref:l},t)),_o=({children:e,onClose:t,...a})=>r.createElement(Wo,{...a},r.createElement(h,{type:"h6",tag:"div"},e),t&&r.createElement(Oo,{"aria-label":"close",onClick:t},r.createElement(W,{size:"sm"}))),be=Ce({}),F=()=>{const e=xe(be);if(e===void 0)throw new Error("useSidebarContext should be used within SidebarContext");return e},Lo=i(U)`
    height: 100%;

    & .MuiDrawer-paper {
        display: flex;
        position: sticky;
        box-sizing: content-box;
        left: 0;
        top: 0;
        background-color: ${({theme:e})=>e.vui.colors.surface.white};
        width: ${({$open:e})=>e?o(256):o(64)};
        transition: width 0.2s ease-out;
    }

    & ${pe} {
        padding: ${o(16)} ${o(20)};
        white-space: nowrap;

        &:not(:last-child) {
            border-bottom: 1px solid ${({theme:e})=>e.vui.colors.border.divider.default};
        }
    }
`,No=i.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${({$open:e})=>e?"space-between":"center"};
    gap: ${o(24)};
    padding: ${({$open:e})=>e?`${o(20)} ${o(20)} ${o(20)} ${o(16)}`:`${o(20)} ${o(12)}`};
    height: ${o(76)};
`,qo=i.div`
    display: ${({$open:e})=>e?"flex":"none"};
    align-items: center;
`,jo=i.div`
    display: flex;
    flex-direction: column;
    margin-top: auto;
`,q=i.div`
    display: flex;
    align-items: center;
    color: ${({theme:e,$state:t})=>e.vui.component.sidebar.itemIcon[t].color};
`,ge=i.div`
    position: relative;
    display: flex;
    align-items: center;
    gap: ${o(12)};
    padding: ${o(8)};
    border-radius: 8px;
    color: ${({theme:e,$state:t})=>e.vui.component.sidebar.item[t].color};
    background-color: ${({theme:e,$state:t})=>e.vui.component.sidebar.item[t].backgroundColor};
    white-space: nowrap;
    cursor: pointer;

    @media (hover: hover) {
        &:hover {
            color: ${({theme:e,$state:t})=>e.vui.component.sidebar.item[t].hover.color};
            background-color: ${({theme:e,$state:t})=>e.vui.component.sidebar.item[t].hover.backgroundColor};

            ${q} {
                color: ${({theme:e,$state:t})=>e.vui.component.sidebar.itemIcon[t].hoverColor};
            }
        }
    }

    &:focus-visible {
        outline: 2px solid ${({theme:e})=>e.vui.colors.border.primary.emphasis};
    }

    ${({$state:e})=>e==="active"&&f`
            &::before {
                content: '';
                position: absolute;
                left: ${o(-12)};
                height: 100%;
                width: 3px;
                border-radius: 0 8px 8px 0;
                background-color: ${({theme:t})=>t.vui.colors.border.default.pressed};
            }
        `}
`,Go=i.div`
    display: flex;
    flex-direction: column;
    gap: ${o(2)};
    padding: 0 ${o(12)};
    flex-grow: 1;

    .active ${ge} {
        color: ${({theme:e})=>e.vui.colors.text.primary};
        background-color: ${({theme:e})=>e.vui.colors.surface.paleBlue};

        ${q} {
            color: ${({theme:e})=>e.vui.colors.icon.primary};
        }

        &::before {
            content: '';
            position: absolute;
            left: ${o(-12)};
            height: 100%;
            width: 3px;
            border-radius: 0 8px 8px 0;
            background-color: ${({theme:e})=>e.vui.colors.border.default.pressed};
        }

        @media (hover: hover) {
            &:hover {
                background-color: ${({theme:e})=>e.vui.colors.surface.blue};
            }
        }
    }
`,Vo=i(h)`
    display: ${({$open:e})=>e?"block":"none"};
`,Ko=i(S)`
    display: flex;
    height: ${o(36)};
    width: ${o(36)};
    color: ${({theme:e})=>e.vui.colors.icon.graySubtle};
    border-radius: 8px;
    border: 1px solid ${({theme:e})=>e.vui.colors.border.divider.default};

    @media (hover: hover) {
        &:hover {
            color: ${({theme:e})=>e.vui.colors.icon.grayMuted};
            border-color: ${({theme:e})=>e.vui.colors.border.muted.default};
            background-color: transparent;
        }
    }
`,Uo=({children:e,open:t,toggle:a})=>r.createElement(be.Provider,{value:{open:t,toggle:a}},r.createElement(Lo,{variant:"permanent",anchor:"left",$open:t},e)),Zo=({children:e})=>{const{open:t}=F();return r.createElement(No,{$open:t},e)},Jo=({children:e})=>{const{open:t}=F();return r.createElement(qo,{$open:t},e)},Qo=({iconClose:e,iconOpen:t})=>{const{open:a,toggle:l}=F(),c=e||r.createElement(Ie,null),s=t||r.createElement(Se,null),d=a?"Close menu":"Open menu";return r.createElement(Ne,{title:d},r.createElement(Ko,{"aria-label":d,onClick:l},a?c:s))},Xo=({icon:e,children:t,active:a=!1,...l})=>{const c=g(),{open:s}=F(),d=a?"active":"default";return r.createElement(ge,{$state:d,...l},r.createElement(q,{$state:d},e),t&&r.createElement(Vo,{type:c.vui.platform==="web"?"caption1":"caption",$open:s},t))},Yo=({icon:e,children:t,href:a="#",...l})=>{const c=g(),{open:s}=F();return r.createElement(he,{leftIcon:e,href:a,...l},s&&r.createElement(h,{type:c.vui.platform==="web"?"caption1":"caption",tag:"span"},t))},er=i(qe)`
    .MuiPaper-root {
        padding: ${o(8)} 0;
        box-shadow: 0 2px 4px rgba(23, 51, 91, 0.2);
    }
    .MuiMenuItem-root {
        font: inherit;
        min-height: auto;
    }
`,tr=i.div`
    gap: ${o(12)};
    color: ${({theme:e,$variant:t})=>t==="destructive"?e.vui.colors.text.error:e.vui.colors.text.grayDefault};
    padding: ${o(6)} ${o(16)};

    @media (hover: hover) {
        &:hover {
            background-color: ${({theme:e})=>e.vui.colors.action.link.hovered};
        }
    }

    &:active {
        background-color: ${({theme:e})=>e.vui.colors.action.link.pressed};
    }
`,or=i.div`
    display: flex;
    align-items: center;
`,rr=i.div`
    display: inline-block;
`,nr=i.img`
    height: ${o(40)};
    width: ${o(40)};
    object-fit: contain;
    border-radius: 50%;
`,ir={vertical:"bottom",horizontal:"right"},ar={vertical:"top",horizontal:"right"},lr=b(({children:e,open:t,onClose:a,anchorComponent:l,...c},s)=>{const d=I(null);return r.createElement("div",null,r.createElement(rr,{ref:d},l),r.createElement(er,{ref:s,open:t,onClose:a,anchorEl:d.current,getContentAnchorEl:null,anchorOrigin:ir,transformOrigin:ar,...c},e))}),dr=b(({children:e,icon:t,imgSrc:a,variant:l="default",...c},s)=>r.createElement(je,{component:tr,$variant:l,ref:s,...c,button:!0},r.createElement(or,null,t),a?r.createElement(nr,{src:a}):null,r.createElement(h,{type:"body1",tag:"span"},e))),cr=i(Ge).attrs(()=>({component:ue}))`
    padding: 0;
`,sr=i(Ve)`
    font: inherit;
`,ur=i(Ke)`
    color: ${({theme:e})=>e.vui.colors.text.grayDefault};
    font: inherit;
`,ve=i(Ue)`
    font: inherit;
    line-height: 1.5;
    padding: ${o(12)} ${o(20)};
    border: 0;

    ${({$action:e})=>e&&f`
            display: flex;
            justify-content: flex-end;
            gap: ${o(4)};
        `}
`,$e=i(Ze)`
    height: ${o(60)};
    border-bottom: 1px solid ${({theme:e})=>e.vui.colors.border.divider.default};
`,pr=i(Je)`
    color: ${({theme:e})=>e.vui.colors.text.grayMuted} ${$e} {
        height: ${o(62)};
    }

    ${ve} {
        ${({theme:e})=>e.vui.typography.web.caption1}
        line-height: 1.5;
    }
`,mr=i.div`
    display: flex;
    gap: 1rem;
`,hr=i(S)`
    align-self: flex-start;
    border-radius: 4px;
    padding: 0;
`,br=i(W)`
    color: #fff;
    stroke: #fff;

    @media (hover: hover) {
        &:hover {
            color: ${({theme:e})=>e.vui.colors.action.link.hovered};
            stroke: ${({theme:e})=>e.vui.colors.action.link.hovered};
        }
    }

    &:active {
        color: ${({theme:e})=>e.vui.colors.action.link.pressed};
        stroke: ${({theme:e})=>e.vui.colors.action.link.pressed};
    }
`,gr=st(e=>({arrow:{color:e.vui.colors.surface.secondary,fontSize:"1.25rem"},popper:{zIndex:e.vui.component.tooltip.popper.zIndex},popperArrow:{'&[x-placement*="left"] $arrow':{marginBottom:"0.5em",marginTop:"0.5em"},'&[x-placement*="right"] $arrow':{marginBottom:"0.5em",marginTop:"0.5em"},'&[x-placement*="top"] $arrow':{marginRight:"0.5em",marginLeft:"0.5em"},'&[x-placement*="bottom"] $arrow':{marginRight:"0.5em",marginLeft:"0.5em"}},tooltip:{backgroundColor:e.vui.colors.surface.secondary,borderRadius:"0.75rem",color:"#fff",padding:"0.5rem"},tooltipPlacementTop:{margin:"1rem 0"},tooltipPlacementBottom:{margin:"1rem 0"},tooltipPlacementRight:{margin:"0 1.25rem"},tooltipPlacementLeft:{margin:"0 1.25rem"}}))(ct),vr=i(h)`
    padding: 0.5rem;
`,$r=i(ze)`
    color: ${({theme:e})=>e.vui.colors.action.primary.default};

    @media (hover: hover) {
        &:hover {
            color: ${({theme:e})=>e.vui.colors.action.primary.hovered};
        }
    }

    &:active {
        color: ${({theme:e})=>e.vui.colors.action.primary.pressed};
    }
`,fr=({content:e,placement:t})=>{const{inView:a,ref:l}=dt({threshold:.3}),c=nt(),{switchOff:s,toggle:d,value:u}=it(!1);j(()=>{!a&&u&&s()},[a]);const p=t||(c?"top":"right");return r.createElement(Qe,{onClickAway:s},r.createElement("div",{ref:l},r.createElement(gr,{arrow:!0,disableFocusListener:!0,disableHoverListener:!0,disableTouchListener:!0,interactive:!0,open:u,placement:p,title:r.createElement(mr,null,r.createElement(vr,{type:"body1"},e),r.createElement(hr,{"aria-label":"close-tooltip",onClick:s,autoFocus:!0},r.createElement(br,{size:"sm"})))},r.createElement($r,{onClick:d}))))},yr=Be`
  ${Xe()};

  html,
  body,
  #root {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  html {
    font-size: 16px;
  }

  body {
    color: #000;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  ul[class],
  ol[class] {
    padding: 0;
  }

  body,
  h1,
  h2,
  h3,
  h4,
  p,
  ul[class],
  ol[class],
  li,
  figure,
  figcaption,
  blockquote,
  dl,
  dd {
    margin: 0;
  }
`,Cr={accent:{orange:"#E68842",orangeText:"#E68842",pink:"#B64878"},feedback:{greenSuccess:"#31AD6D",greenSuccessText:"#1C8750",redError:"#D90012"},general:{black:"#000000",white:"#FFFFFF"},neutral:{gray25:"#F8F8F9",gray5:"#F0F2F3",gray40:"#9299A2",gray60:"#626A74",gray75:"#424851",gray80:"#373D45",gray85:"#2D333A",gray90:"#24282E",gray95:"#1D2025",gray875:"#282D34",gray10:"#E2E4E8",gray30:"#ABB1B9"},primary:{blue:"#007CBA",navy:"#17335B",navy70:"#5D708C",navy80:"#455C7C",navy90:"#2E476B",primaryBlue:"#0080A3",turquoise:"#00BBDC"},secondary:{athensGray:"#E3E7EB",blueHighlight:"#00A8C6",ghost:"#C6CBD1",iceberg:"#D9ECF1",veniceBlue:"#06668A",whiteCatskill:"#F2F8F9"}},n={background:{white:"#FFFFFF",blue:"#F2F8F9",gray:"#F8F8F9"},text:{navyDefault:"#17335B",navyMuted:"#455C7C",grayDefault:"#24282E",grayMuted:"#373D45",graySubtle:"#626A74",emphasis:"#FFFFFF",primary:"#0080A3",success:"#1C8750",attention:"#CF7A3B",error:"#CB002C",hint:"#9299A2",disabled:"#9299A2"},icon:{navyDefault:"#17335B",navyMuted:"#455C7C",grayDefault:"#24282E",grayMuted:"#373D45",graySubtle:"#626A74",grayPale:"#9299A2",emphasis:"#FFFFFF",primary:"#0080A3",success:"#31AD6D",attention:"#E68842",error:"#CB002C",disabled:"#9299A2"},surface:{white:"#FFFFFF",navy:"#17335B",contrastBlue:"#17427B",blue:"#E5F1F4",paleBlue:"#F2F8F9",lightGray:"#F8F8F9",primary:"#D9ECF1",success:"#E0F3E9",attention:"#FFF7F0",error:"#F9D9DB",secondary:"#2C3542"},border:{default:{default:"#ABB1B9",hovered:"#626A74",pressed:"#0080A3",disabled:"#E2E4E8"},muted:{default:"#C6CBD1",hovered:"#06668A",pressed:"#06668A",disabled:"#E2E4E8"},divider:{default:"#E2E4E8"},primary:{default:"#B3D9E3",emphasis:"#0080A3",disabled:"#E2E4E8"},secondary:{default:v("#0080A3",.3)},success:{default:"#C1E7D3",emphasis:"#31AD6D",disabled:"#E2E4E8"},attention:{default:"#F8D8C6",emphasis:"#E68842",disabled:"#E2E4E8"},error:{default:"#EFB3C0",emphasis:"#CB002C",disabled:"#E2E4E8"}},action:{primary:{default:"#0080A3",hovered:"#00A8C6",pressed:"#06668A",disabled:"#F0F2F3"},secondary:{default:"#FFFFFF",hovered:v("#00A8C6",.15),pressed:v("#00A8C6",.3),disabled:"#FFFFFF"},link:{default:"#FFFFFF",hovered:"#F0F2F3",pressed:"#E2E4E8",disabled:"#FFFFFF"},tertiary:{default:"#F0F2F3",hovered:v("#00A8C6",.15),pressed:v("#00A8C6",.3),disabled:"#F0F2F3"},destructive:{default:"#FFFFFF",hovered:v("#CB002C",.15),pressed:v("#CB002C",.3)}},decorative:{neutral:{gray95:"#1D2025",gray90:"#24282E",gray875:"#282D34",gray85:"#2D333A",gray80:"#373D45",gray75:"#424851",gray60:"#626A74",gray50:"#7A818B",gray40:"#9299A2",gray30:"#ABB1B9",gray20:"#C6CBD1",gray10:"#E2E4E8",gray5:"#F0F2F3",gray025:"#F8F8F9"},navy:{navy:"#17335B",navy90:"#2E476B",navy80:"#455C7C",navy70:"#5D708C"},pink:{pink:"#B64878",pink90:"#BD5A85"},turquoise:{turquoise:"#00BBDC",turquoise80:"#33C9E3",turquoise30:"#B3EBF5",turquoise20:"#CCF1F8"}},...Cr},xr={default:{textColor:n.text.grayMuted}},kr={default:{backgroundColor:n.background.white,titleColor:n.text.grayMuted,contentColor:n.text.grayMuted,borderColor:n.border.muted.default},selected:{backgroundColor:n.background.white,titleColor:n.text.grayMuted,contentColor:n.text.grayMuted,borderColor:n.border.muted.pressed}},Er={size:{large:{borderRadius:"8px",padding:o(16),size:o(56)},medium:{borderRadius:"8px",padding:o(12),size:o(48)},small:{borderRadius:"4px",padding:o(6),size:o(36)}},variant:{default:{color:n.icon.graySubtle,background:n.action.link.default},disabled:{color:n.icon.disabled,background:n.action.link.disabled},hover:{color:n.icon.grayMuted,background:n.action.link.hovered},pressed:{color:n.icon.grayMuted,background:n.action.link.pressed}}},wr={size:{large:{borderRadius:"999px",fontSize:o(18),lineHeight:"1.25",padding:o(16)},medium:{borderRadius:"999px",fontSize:o(18),lineHeight:"1.6",padding:`${o(9)} ${o(16)}`},small:{borderRadius:"999px",fontSize:o(14),lineHeight:"1.7",padding:`${o(5.5)} ${o(16)}`}},variant:{destructive:{default:{background:n.action.destructive.default,border:n.border.error.emphasis,font:n.text.error},disabled:{background:n.action.destructive.default,border:n.border.error.emphasis,font:n.text.error},hover:{background:n.action.destructive.hovered,border:n.border.error.emphasis,font:n.text.error},pressed:{background:n.action.destructive.pressed,border:n.border.error.emphasis,font:n.text.error}},link:{default:{background:n.action.link.default,border:"transparent",font:n.text.primary},disabled:{background:n.action.link.disabled,border:"transparent",font:n.text.disabled},hover:{background:n.action.link.hovered,border:"transparent",font:n.text.primary},pressed:{background:n.action.link.pressed,border:"transparent",font:n.text.primary}},primary:{default:{background:n.action.primary.default,border:"transparent",font:n.text.emphasis},disabled:{background:n.action.primary.disabled,border:"transparent",font:n.text.disabled},hover:{background:n.action.primary.hovered,border:"transparent",font:n.text.emphasis},pressed:{background:n.action.primary.pressed,border:"transparent",font:n.text.emphasis}},tertiary:{default:{background:n.action.tertiary.default,border:"transparent",font:n.text.primary},disabled:{background:n.action.tertiary.disabled,border:"transparent",font:n.decorative.neutral.gray30},hover:{background:n.action.tertiary.hovered,border:"transparent",font:n.text.primary},pressed:{background:n.action.tertiary.pressed,border:"transparent",font:n.text.primary}},secondary:{default:{background:n.action.secondary.default,border:n.border.secondary.default,font:n.text.primary},disabled:{background:n.action.tertiary.disabled,border:n.border.primary.disabled,font:n.text.disabled},hover:{background:n.action.secondary.hovered,border:n.border.secondary.default,font:n.text.primary},pressed:{background:n.action.secondary.pressed,border:n.border.secondary.default,font:n.text.primary}}}},Fr={padding:o(20),borderRadius:o(8),backgroundColor:n.background.white,boxShadow:`0px 2px 4px ${v(n.decorative.navy.navy,.2)}`},Ir={variant:{default:{primary:{backgroundColor:n.action.primary.default,color:n.text.emphasis,border:"transparent",hoverBgColor:n.action.primary.hovered},default:{backgroundColor:n.decorative.neutral.gray5,color:n.text.grayMuted,border:"transparent",hoverBgColor:n.decorative.neutral.gray40}},outlined:{primary:{backgroundColor:n.background.white,color:n.text.primary,border:n.border.default.pressed,hoverBgColor:n.decorative.neutral.gray40},default:{backgroundColor:n.background.white,color:n.text.grayMuted,border:n.decorative.neutral.gray80,hoverBgColor:n.decorative.neutral.gray40}}}},Sr={default:{default:{backgroundColor:n.background.white,borderColor:n.border.default.default,borderWidth:1,textColor:n.text.grayMuted},focus:{backgroundColor:n.background.white,borderColor:n.border.primary.emphasis,borderWidth:2,textColor:n.text.grayMuted},hover:{backgroundColor:n.background.white,borderColor:n.border.default.hovered,borderWidth:1,textColor:n.text.grayMuted}},disabled:{default:{backgroundColor:n.background.gray,borderColor:n.border.default.disabled,borderWidth:1,textColor:n.text.disabled},focus:{backgroundColor:n.background.gray,borderColor:n.border.default.disabled,borderWidth:1,textColor:n.text.disabled},hover:{backgroundColor:n.background.gray,borderColor:n.border.default.disabled,borderWidth:1,textColor:n.text.disabled}},error:{default:{backgroundColor:n.background.white,borderColor:n.border.error.emphasis,borderWidth:2,textColor:n.text.grayMuted},focus:{backgroundColor:n.background.white,borderColor:n.border.error.emphasis,borderWidth:2,textColor:n.text.grayMuted},hover:{backgroundColor:n.background.white,borderColor:n.border.error.emphasis,borderWidth:2,textColor:n.text.grayMuted}}},zr={container:{backgroundColor:n.background.white,borderRadius:o(8)},overlay:{backgroundColor:v(10,10,10,.86)},timeout:50,border:`1px solid ${n.border.divider.default}`},Mr={item:{default:{backgroundColor:"transparent",color:n.text.grayMuted,hover:{backgroundColor:n.background.gray,color:n.text.grayDefault}},active:{backgroundColor:n.surface.paleBlue,color:n.text.primary,hover:{backgroundColor:n.surface.blue,color:n.text.primary}}},itemIcon:{default:{color:n.icon.graySubtle,hoverColor:n.icon.grayDefault},active:{color:n.icon.primary,hoverColor:n.icon.primary}}},Br={color:n.text.primary,size:"3rem"},Dr={background:n.background.blue,default:{color:n.text.graySubtle},indicator:{color:n.decorative.turquoise.turquoise},selected:{color:n.text.navyDefault}},Tr={popper:{zIndex:10}},Ar={android:{body1:{fontSize:o(16),fontWeight:"400",lineHeight:"1.5"},body2:{fontSize:o(14),fontWeight:"400",lineHeight:"1.4"},caption:{fontSize:o(12),fontWeight:"500",lineHeight:"1.3"},h1:{fontSize:o(34),fontWeight:"700",lineHeight:"1.2"},h2:{fontSize:o(28),fontWeight:"500",lineHeight:"1.2"},h3:{fontSize:o(24),fontWeight:"500",lineHeight:"1.25"},h4:{fontSize:o(20),fontWeight:"500",lineHeight:"1.3"},sub1:{fontSize:o(16),fontWeight:"500",lineHeight:"1.375"},sub2:{fontSize:o(14),fontWeight:"500",lineHeight:"1.4"},titleCaps:{fontSize:o(14),fontWeight:"500",lineHeight:"1.4"}},ios:{body1:{fontSize:o(16),fontWeight:"400",lineHeight:"1.5"},body2:{fontSize:o(14),fontWeight:"400",lineHeight:"1.4"},caption:{fontSize:o(12),fontWeight:"500",lineHeight:"1.3"},h1:{fontSize:o(34),fontWeight:"700",lineHeight:"1.2"},h2:{fontSize:o(28),fontWeight:"600",lineHeight:"1.2"},h3:{fontSize:o(24),fontWeight:"600",lineHeight:"1.25"},h4:{fontSize:o(20),fontWeight:"500",lineHeight:"1.3"},sub1:{fontSize:o(16),fontWeight:"600",lineHeight:"1.375"},sub2:{fontSize:o(14),fontWeight:"600",lineHeight:"1.4"},titleCaps:{fontSize:o(14),fontWeight:"600",lineHeight:"1.4"}},web:{body1:{fontSize:o(16),fontWeight:"400",lineHeight:"1.5"},body2:{fontSize:o(14),fontWeight:"400",lineHeight:"1.5"},caption1:{fontSize:o(14),fontWeight:"500",lineHeight:"1.3"},caption2:{fontSize:o(12),fontWeight:"500",lineHeight:"1.3"},h1:{fontSize:o(48),fontWeight:"700",lineHeight:"1.3"},h2:{fontSize:o(40),fontWeight:"500",lineHeight:"1.3"},h3:{fontSize:o(32),fontWeight:"500",lineHeight:"1.375"},h4:{fontSize:o(24),fontWeight:"500",lineHeight:"1.3"},h5:{fontSize:o(20),fontWeight:"500",lineHeight:"1.4"},h6:{fontSize:o(16),fontWeight:"500",lineHeight:"1.5"},sub1:{fontSize:o(40),fontWeight:"400",lineHeight:"1.3"},sub2:{fontSize:o(32),fontWeight:"400",lineHeight:"1.375"},sub3:{fontSize:o(24),fontWeight:"400",lineHeight:"1.3"},sub4:{fontSize:o(20),fontWeight:"400",lineHeight:"1.4"},titleCaps:{fontSize:o(14),fontWeight:"600",lineHeight:"1.4"}}},Wr=ut({vui:{colors:n,component:{autocomplete:xr,button:wr,chip:Ir,input:Sr,spinner:Br,tab:Dr,buttonCard:kr,modal:zr,card:Fr,sidebar:Mr,buttonIcon:Er,tooltip:Tr},typography:Ar,platform:"ios"},props:{MuiButton:{disableElevation:!0},MuiButtonBase:{disableRipple:!0,disableTouchRipple:!0}}}),Hr=({children:e,theme:t})=>r.createElement(pt,{injectFirst:!0},r.createElement(mt,{theme:t},r.createElement(De,{theme:t},e))),Rr="0.36.5";export{Xt as Autocomplete,re as AutocompleteComponents,eo as Button,go as ButtonCard,se as ButtonIcon,ue as Card,Mo as Checkbox,uo as Chip,Io as Divider,Po as Drawer,Ho as DrawerContent,Ro as DrawerFooter,_o as DrawerHeader,lr as DropdownMenu,dr as DropdownMenuItem,yr as GlobalStyles,po as Input,he as Link,Et as List,Q as ListItem,Eo as Modal,xo as ModalContent,ko as ModalFooter,Co as ModalHeader,To as Radio,Uo as Sidebar,Qo as SidebarCollapseButton,Go as SidebarContent,jo as SidebarFooter,Zo as SidebarHeader,Jo as SidebarHeaderContent,Xo as SidebarItem,Yo as SidebarLinkItem,oo as Spinner,co as Tab,sr as Table,ur as TableBody,ve as TableCell,cr as TableContainer,pr as TableHead,$e as TableRow,ao as Tabs,h as Text,fr as Tooltip,Hr as VillageUIThemeProvider,Wr as defaultVillageUiTheme,Rr as version};
//# sourceMappingURL=index.js.map
